const TopParent = ({ children }) => {
    return (
        <main className="h-[100%] w-[100%]">
            {children}
        </main>
    );
};

export default TopParent;
